<template>
  <card id="quickAdd" icon="fas fa-plus" title="Quick Add Product" class="mb-3" bodyClasses="p-3">
    <AutoComplete 
      v-model="selectedAddProduct" 
      :suggestions="quickSearchProductResults" 
      @complete="quickSearchProducts($event)" 
      field="sku" 
      @item-select="quickAddProduct($event)" 
      :autoHighlight="true"
      :minLength="2"
      :delay="300" 
      placeholder="SKU">
      <template #item="slotProps">
        <span v-if="slotProps.item.id == -1">Add Custom Product </span>{{ slotProps.item.sku }}<span v-if="slotProps.item.id != -1"> - {{ formatDollars(isWholesale ? slotProps.item.wholesale_price : slotProps.item.user_price) }}</span>
      </template>
    </AutoComplete>
  </card>   

  <AddCustomProduct :form="formAddProduct"/>

</template> 

<script>
  import AutoComplete from 'primevue/autocomplete'

  import AddCustomProduct from '@/Components/Modals/AddCustomProduct'


  export default {
    data() {
      return {
        formCart: this.$inertia.form({
          qty: null,
          product_id: null
        }),
        formAddProduct: this.$inertia.form({
          sku: null,
          name: null,
          user_price: null
        }),
        quickSearchProductResults: [],
        selectedAddProduct: null
      }
    },
    components: {
      AutoComplete,
      AddCustomProduct
    },
    props: {
      isWholesale: {
        type: Boolean,
        default: false
      },
      update: Function,
    },
    methods: {
      quickSearchProducts(event) {

          axios.post(this.route('mtd.products.search'), {query: event.query, wholesale:this.isWholesale}).then((response) => {
            if (response.data.success) {
              this.quickSearchProductResults = response.data.results;
              if (!this.isWholesale) {
                this.quickSearchProductResults[this.quickSearchProductResults.length] = {id: -1, sku: event.query}
              }
            }
          });
      },
      quickAddProduct(event) {
        if (this.formCart.processing) return

        let product = event.value;
        if (!product) {
          return;
        }
        
        this.selectedAddProduct = null;

        if (product.id != -1) {
          this.formCart.qty = 1,
          this.formCart.product_id =  product.id

          this.formCart.post(this.route(this.isWholesale ? 'mtd.cart.add' : 'cart.add', product.id), { 
            preserveScroll: true,
            onSuccess: () => {
              this.update() 
              this.trackAddToCart(
                product,
                1,
                this.$page.props
              );
            }
          });
        } else {
          this.formAddProduct.sku = event.value.sku;

          $('#quickAddProductModal').modal('show')
        }
      },
    }
  }
</script>
